// extracted by mini-css-extract-plugin
export default {"usefulQuestions":"POIhF _20SLo _38YTw"};